import { Actions, getRolesSuccess, getRolesFailure, getRolesRequest } from 'actions/roleActions';
import { Actions as SessionActions } from 'actions/sessionActions';
import { Role } from 'shared/models';
import { apiGet } from './apiSagas';
import { call, put, take, takeLatest } from 'redux-saga/effects';
import { Dictionary } from 'lodash';
import { toError } from 'shared/util/toError';

export function* loginWatcher() {
    yield takeLatest(SessionActions.LOGIN_SUCCESS, function*() {
        yield put(getRolesRequest());
    });
}

export function* getRolesSaga() {
    while (true) {
        yield take(Actions.GET_ROLES_REQUEST);

        try {
            const roles: Dictionary<Role> = yield call(apiGet, '/api/roles');
            yield put(getRolesSuccess(roles));
        }
        catch (e) {
            const err = toError(e);
            yield put(getRolesFailure(err));
        }
    }
}
